<template>
  <div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="showDialog"
      width="841px"
      @close="setDialogClosed"
      append-to-body
    >
      <el-container direction="vertical">
        <el-row v-for="(item, index) in list" :key="index">
          <el-descriptions :column="4" border style="margin-bottom: 10px">
            <el-descriptions-item label="样本">{{
              item.sampleName
            }}</el-descriptions-item>
            <el-descriptions-item label="项目">{{
              item.itemName
            }}</el-descriptions-item>
            <el-descriptions-item label="采集时间">{{
              getParsedTime(item.collectTime)
            }}</el-descriptions-item>
            <el-descriptions-item label="接收时间">{{
              getParsedTime(item.receivedTime)
            }}</el-descriptions-item>
          </el-descriptions>

          <el-table
            v-loading="listLoading"
            :data="item.results"
            border
            fit
            highlight-current-row
            style="width: 100%; margin-bottom: 30px"
          >
            <el-table-column width="100px" align="center" label="项目编码">
              <template slot-scope="scope">
                <span>{{ scope.row.itemCode }}</span>
              </template>
            </el-table-column>

            <el-table-column width="200px" align="center" label="项目名称">
              <template slot-scope="scope">
                <span>{{ scope.row.itemName }}</span>
              </template>
            </el-table-column>

            <el-table-column width="100px" align="center" label="结果">
              <template slot-scope="scope">
                <span>{{ getObservedValue(scope.row) }}</span>
              </template>
            </el-table-column>

            <el-table-column width="200px" align="center" label="参考值">
              <template slot-scope="scope">
                <span>{{ scope.row.ranges }}</span>
              </template>
            </el-table-column>

            <el-table-column width="100px" align="center" label="单位">
              <template slot-scope="scope">
                <span>{{ scope.row.unitName }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-container>

    </el-dialog>
  </div>
</template>

<script>
import { getLabInfoDetail } from "@/api/health/LabQuery";
import moment from "moment";
import { getAllTestItems } from "@/api/health/HealthManagementQuery";

export default {
  components: { },
  data() {
    return {
      showDialog: false,
      title: "检验记录详情",
      list: null,
      listLoading: false
    };
  },
  methods: {
    // 编辑初始化页面内容
    async init(dataContext) {
      console.log("初始化内容", dataContext);
      this.showDialog = true;
      this.title = dataContext.name;
      this.$nextTick(() => {
        this.getReportsList(dataContext.id);
      });
    },
    // 关闭对话框触发
    setDialogClosed() {
      this.showDialog = false;
    },
    getParsedTime(time) {
      if (time != null) {
        return moment(time).format("YYYY-MM-DD HH:mm");
      }else{
        return '';
      }      
    },
    getReportsList(itemId) {
      this.listLoading = true;
      getLabInfoDetail(itemId).then((response) => {
        console.log(response);
        this.list = response.testItems;
        this.listLoading = false;
      });
    },
    getObservedValue(row) {
      if (row.hasOwnProperty("anomaly")) {
        if (row.anomaly != null) {
          return row.observedValue + row.anomaly;
        }else{
          return row.observedValue;
        }      
      } else {
        return row.observedValue;
      }
    }
  },
};
</script>

<style lang="less" scoped>
</style>